import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-texto-tag',
  templateUrl: './texto-tag.component.html',
  styleUrls: ['./texto-tag.component.scss'],
})
export class TextoTagComponent {
  @Input() public tag: string = '';
  @Input() public pageIndex = true;

  @Input() public destaque: boolean = false;

  public exibirIcone(): boolean {
    const tag: string = this.tag.toLocaleLowerCase();
    let exibir: boolean = false;

    const palavrasChave: string[] = ['valor', 'cacau'];
    palavrasChave.forEach((palavraChave: string) => {
      if (tag.includes(palavraChave)) exibir = true;
    });

    return exibir;
  }
}
